import { MdCalendarToday } from "react-icons/md";
import "bootstrap-daterangepicker/daterangepicker.css";
import classNames from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { getDateRanges } from "../../../helpers";

const SelectCalendarFilter = ({
  label,
  placeholder,
  value,
  className,
  onDateChange,
  setFieldValue,
  name,
}) => {
  const [selectedDateRange, setSelectedDateRange] = useState("");
  const ranges = getDateRanges();

  useEffect(() => {
    if (value && value.from && value.to) {
      const fromInMilliseconds = value.from * 1000;
      const toInMilliseconds = value.to * 1000;
      const formattedDateRange =
        moment(fromInMilliseconds).format("MMM D, YYYY hh:mma") +
        " - " +
        moment(toInMilliseconds).format("MMM D, YYYY hh:mma");

      if (formattedDateRange !== selectedDateRange) {
        setDate(fromInMilliseconds, toInMilliseconds, false);
      }
    } else if (Object.prototype.hasOwnProperty.call(ranges, value)) {
      setDate(ranges[value][0], ranges[value][1], false);
    }
  }, [value, selectedDateRange, ranges]);

  const changeDate = useCallback(
    (event, range) => {
      const startDateUnix = range.startDate.unix() * 1000;
      const endDateUnix = range.endDate.seconds(59).unix() * 1000;
      setDate(startDateUnix, endDateUnix, true);
      if (onDateChange) {
        onDateChange();
      }
    },
    [onDateChange]
  );

  const setDate = useCallback(
    (startDateUnix, endDateUnix, shouldSetFieldValue = true) => {
      let newValue = {};
      if (startDateUnix && endDateUnix) {
        newValue = {
          from: Math.floor(startDateUnix / 1000),
          to: Math.floor(endDateUnix / 1000),
        };

        setSelectedDateRange(
          moment(startDateUnix).format("MMM D, YYYY hh:mma") +
            " - " +
            moment(endDateUnix).format("MMM D, YYYY hh:mma")
        );
      } else {
        setSelectedDateRange("");
      }

      if (shouldSetFieldValue) {
        setFieldValue(name, newValue);
      }
    },
    [setFieldValue, name]
  );

  return (
    <React.Fragment>
      {label && <label className="mb-2 d-block">{label}</label>}
      <div className={classNames("full-width css-p0-container", className)}>
        <DateRangePicker
          onApply={changeDate}
          initialSettings={{
            timePicker: true,
            ranges: getDateRanges(),
          }}
        >
          <InputGroup>
            <FormControl
              placeholder={placeholder || "Select Date"}
              aria-describedby="daterange-picker"
              disabled={true}
              value={selectedDateRange}
            />
            <div className="input-group-append">
              <InputGroup.Text id="daterange-picker">
                <MdCalendarToday className="ic_small" />
              </InputGroup.Text>
            </div>
          </InputGroup>
        </DateRangePicker>
      </div>
    </React.Fragment>
  );
};

SelectCalendarFilter.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number,
  }),
  className: PropTypes.string,
  onDateChange: PropTypes.func,
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export default SelectCalendarFilter;
